module.exports = __webpack_public_path__ + "static/media/nestje6.4d50e7e6.jpg";